module.exports = __webpack_public_path__ + "img/monitoring-truck-blue.72f00d51.svg";